module.exports = __webpack_public_path__ + "videos/beginners-series_16x9.23dc776.mp4";